// import React from "react";
// import ExplorePage from "../components/home/ExploreScreen";

// const Explore = () => {
//   return <ExplorePage />;
// };

// export default Explore;




import React from "react";
import { useAuth } from '../contexts/AuthContext';
import HeaderAuth from '../components/home/HeaderAuth';
import Header from '../components/home/Header';
import ExploreScreen from "../components/home/ExploreScreen";

const Explore = () => {
  const { user } = useAuth();

  return (
    <div>
      {/* Show HeaderAuth if user is logged in, otherwise show Header */}
 
      <ExploreScreen />
    </div>
  );
};

export default Explore;